export default __webpack_public_path__ + "static/media/NotFoundCircleLight.fb2b67ea.svg";